import React from 'react';
import PropTypes from 'prop-types';

import styles from './MonitoringStatusCell.module.scss';
import { monitoringStatus } from '../monitoringSummary/constants';

const MonitoringStatusCell = (props) => {
    const pillstyles = (props.status === monitoringStatus.noBreach) ? { } : { backgroundColor: `#${props.colour}` };
    return (
        <div className={ styles.borderWrapper } style={ pillstyles }>
            <div
                className={ styles.borderMargin }
            >
                { props.status }
            </div>
        </div>
    );
};

MonitoringStatusCell.propTypes = {
    status: PropTypes.string.isRequired,
    colour: PropTypes.string.isRequired
};


export default MonitoringStatusCell;
